import { EntryKinds } from '@i-ark/models';
import { useMutateEntry } from '@utils/component-framework';
import { getItemEntryById } from './utils/get-item-by-id.js';
import { getPageEntryById } from './utils/get-page-by-id.js';

function useChangeInputEntryMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return args => mutater(entry => {
    const page = getPageEntryById(entry.data, args.pageId);
    const item = getItemEntryById(page, args.itemId);
    if (item.entry === undefined && args.value === "") {
      return entry;
    }
    if (item.entry === undefined) {
      item.entry = {
        kind: EntryKinds.INPUT,
        value: ""
      };
    }
    item.entry.value = args.value;
    return entry;
  });
}

export { useChangeInputEntryMutation };
//# sourceMappingURL=change.input.js.map
